import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Pageheader from '../utils/headerHelment';
import WorkspacePulsePage from '../components/WorkspacePulse/WorkspacePulsePage';
import styles from '../components/WorkspacePulse/WorkspacePulse.module.css';
import { resolveWorkspacePulseWorkspaceId } from '../utils/resolveWorkspacePulseWorkspaceId';

const WorkspacePulseView = () => {
    const [searchParams] = useSearchParams();
    const { activeWorkspaceId, memberships, workspacesLoading, access, user } = useSelector(state => ({
        activeWorkspaceId: state.user?.activeWorkspaceId || '',
        memberships: state.user?.memberships || [],
        workspacesLoading: Boolean(state.user?.workspacesLoading),
        access: state.user?.access,
        user: state.user?.user,
    }));

    const workspaceId = resolveWorkspacePulseWorkspaceId({
        searchParams,
        activeWorkspaceId,
        workspacesLoading,
        memberships,
    });
    const authReady = Boolean(user?.id && access);

    if (!authReady || workspacesLoading) {
        return (
            <>
                <Pageheader title="LENS - Workspace Pulse" />
                <div className={styles.centered}>Loading Workspace Pulse…</div>
            </>
        );
    }

    if (!workspaceId) {
        return (
            <>
                <Pageheader title="LENS - Workspace Pulse" />
                <div className={styles.centered}>Select a workspace to view Workspace Pulse.</div>
            </>
        );
    }

    return (
        <>
            <Pageheader title="LENS - Workspace Pulse" />
            <WorkspacePulsePage workspaceId={workspaceId} />
        </>
    );
};

export default WorkspacePulseView;
